import React, { createContext, ReactElement, useEffect, useState } from 'react';
import QueryStringUtil from 'src/utils/QueryStringUtil';

export interface DebugContextProps {
  debugMode: boolean;
  setDebugMode: (debugMode: boolean) => void;
}

export const DebugContext = createContext<DebugContextProps>({
  debugMode: false,
  setDebugMode: () => {
    return;
  },
});

export interface DebugContextProviderProps {
  children?: React.ReactNode;
}

export const DebugContextProvider = ({ children }: DebugContextProviderProps): ReactElement => {
  const [debugMode, setDebugMode] = useState(false);

  useEffect(() => {
    const debugString = QueryStringUtil.getValueByKey('debug');
    const debug = debugString === 'true';
    setDebugMode(debug);
  }, []);

  return (
    <DebugContext.Provider
      value={{
        debugMode: debugMode,
        setDebugMode: setDebugMode,
      }}
    >
      {children}
    </DebugContext.Provider>
  );
};
